import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export const EXOTIC_BETS = [
  { value: 'first-four', label: 'First Four', target: 4 },
  { value: 'trifecta', label: 'Trifecta', target: 3 },
  { value: 'quinella', label: 'Quinella', target: 2 },
  { value: 'lean-quaddie', label: 'Lean Quaddie', target: 4 },
  { value: 'long-quaddie', label: 'Long Quaddie', target: 4 },
] as const;

export type ExoticBet = (typeof EXOTIC_BETS)[number]['value'];

export function isQuaddieBet(bet: ExoticBet): boolean {
  return bet === 'lean-quaddie' || bet === 'long-quaddie';
}

/** One race where analysis types 1, 2 and 3 picked the same horses. */
export interface StraightExoticRow {
  race_id: string;
  horses: string[];
  pick_count: number;
  /** How many of the selections finished in the money; -1 = the race has not run. */
  correct_count: number;
}

export interface QuaddieLeg {
  race_number: number;
  race_id: string;
  horses: string[];
  /** null while the leg has no result. */
  won: boolean | null;
}

export interface QuaddieRow {
  meeting_id: string;
  meeting_date: string;
  track_name: string;
  quaddie_type: 'early' | 'main';
  legs: QuaddieLeg[];
}

export type ExoticRow = StraightExoticRow | QuaddieRow;

export function isQuaddieRow(row: ExoticRow): row is QuaddieRow {
  return 'legs' in row;
}

/** Refetches only when the bet or the *applied* date range changes (see the page's Apply button). */
export function usePredictedExotics(bet: ExoticBet, startDate: string, endDate: string) {
  return useQuery({
    queryKey: ['predicted-exotics', bet, startDate, endDate],
    queryFn: () => {
      const params = new URLSearchParams({ bet, startDate, endDate });
      return apiClient<ExoticRow[]>(`/predicted-exotics?${params.toString()}`);
    },
  });
}
